import api from "./api";

// Goodwill advances to drivers. Interest free and unrelated to trip payouts.
const url = "/api/admin/transport-master/driver-loans";

export const LOAN_PAYMENT_METHODS = ["CASH", "UPI", "BANK_TRANSFER", "OTHER"];

export const getDriverLoanOverview = async ({ driverId, includeSettled = false } = {}) => {
  const { data } = await api.get(url, { params: { driverId: driverId || undefined, includeSettled } });
  return data;
};

export const saveDriverLoan = async (loan) => {
  if (loan.id) {
    const { data } = await api.put(`${url}/${loan.id}`, loan);
    return data;
  }
  const { data } = await api.post(url, loan);
  return data;
};

export const deleteDriverLoan = async (id) => {
  const { data } = await api.delete(`${url}/${id}`);
  return data;
};

export const recordDriverLoanRepayment = async (loanId, repayment) => {
  const { data } = await api.post(`${url}/${loanId}/repayments`, repayment);
  return data;
};

export const deleteDriverLoanRepayment = async (loanId, repaymentId) => {
  const { data } = await api.delete(`${url}/${loanId}/repayments/${repaymentId}`);
  return data;
};
